import { useState } from "react";
import Button from "../../Custom/Button/Button";

const styles = {
  divButton: { height: "60px" }
};

const categoriesLZO = [
  {
    id: 1,
    name: "ZASTITA LICA",
    dokumenta: [
      { id: 1, name: "ZASTITA LICA 1" },
      { id: 2, name: "ZASTITA LICA 2" },
      { id: 3, name: "ZASTITA LICA 3" }
    ]
  },
  {
    id: 2,
    name: "ZASTITA OCIJU",
    dokumenta: [
      { id: 4, name: "ZASTITA OCIJU 1" },
      { id: 5, name: "ZASTITA OCIJU 2" },
      { id: 6, name: "ZASTITA OCIJU 3" }
    ]
  },
  {
    id: 3,
    name: "ZASTITA GLAVE",
    dokumenta: [
      { id: 7, name: "ZASTITA GLAVE 1" },
      { id: 8, name: "ZASTITA GLAVE 2" },
      { id: 9, name: "ZASTITA GLAVE 3" }
    ]
  }
];

const FolderDocumentSidebar = ({ selectedCompany }) => {
  // 0,1,2,3,4,5,6,7
  const [selectedButton, setSelectedButton] = useState(0);
  const [activeLZOIds, setActiveLZOIds] = useState([]);

  const handleClick = (id) => {
    if (selectedButton === id) {
      setSelectedButton(0);
    } else {
      setSelectedButton(id);
    }
  };

  const handleClickLZOCategory = (id) => {
    if (activeLZOIds.includes(id)) {
      setActiveLZOIds(activeLZOIds.filter((i) => i !== id));
    } else {
      setActiveLZOIds([...activeLZOIds, id]);
    }
  };

  return (
    <div style={{ overflowY: "auto", zIndex: 1000 }}>
      <div onClick={() => handleClick(1)} style={styles.divButton}>
        <Button active={selectedButton === 1}>RAZNO</Button>
      </div>
      <div onClick={() => handleClick(2)} style={styles.divButton}>
        <Button active={selectedButton === 2}>LZO - NAMENA I STANDARDI</Button>
      </div>
      {selectedButton === 2 && (
        <div
          style={{
            backgroundColor: "white",
            display: "flex",
            flexDirection: "column",
            gap: "15px",
            padding: "10px"
          }}
        >
          {categoriesLZO.map((category) => (
            <div key={category.id}>
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <div
                  onClick={() => handleClickLZOCategory(category.id)}
                  style={{ minWidth: "30px" }}
                >
                  <Button activation={true} style={{ fontWeight: "bold" }}>
                    {activeLZOIds.includes(category.id) ? "-" : "+"}
                  </Button>
                </div>
                <div
                  style={{
                    fontWeight: "bold",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                  }}
                >
                  {category.name}
                </div>
              </div>

              {activeLZOIds.includes(category.id) && (
                <div
                  style={{
                    marginTop: "10px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px"
                  }}
                >
                  {category.dokumenta.map((dokument) => (
                    <div
                      key={dokument.id}
                      style={{
                        borderBottom: "1px solid black",
                        padding: "3px",
                        paddingLeft: "30px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis"
                      }}
                    >
                      {dokument.name}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
      <div onClick={() => handleClick(3)} style={styles.divButton}>
        <Button active={selectedButton === 3}>RAZNI PROCESI</Button>
      </div>
      <div onClick={() => handleClick(4)} style={styles.divButton}>
        <Button active={selectedButton === 4}>RAZNI RIZICI</Button>
      </div>
      <div onClick={() => handleClick(5)} style={styles.divButton}>
        <Button active={selectedButton === 5}>RAZNE MERE</Button>
      </div>
      <div onClick={() => handleClick(6)} style={styles.divButton}>
        <Button active={selectedButton === 6}>FORMATIRANA UPUTSTVA</Button>
      </div>
      <div onClick={() => handleClick(7)} style={styles.divButton}>
        <Button active={selectedButton === 7}>RAZNE FORME</Button>
      </div>
    </div>
  );
};

export default FolderDocumentSidebar;
